import React from "react";
import { FaPinterest } from "@react-icons/all-files/fa/FaPinterest";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function PinCover({ base, cover, path, description }) {
  const url = base + path;
  const media = base + cover.publicURL;

  const link = `https://www.pinterest.com/pin/create/bookmarklet/?url=${encodeURI(
    url
  )}&media=${encodeURI(media)}&is_video=false&description=${encodeURI(
    description
  )}`;

  return (
    <a
      href={link}
      className="group relative w-full h-auto"
      data-pin-url={url}
      data-pin-media={media}
      data-pin-description={description}
    >
      <GatsbyImage
        image={getImage(cover)}
        className="top-0 left-0"
        alt={description}
      />
      <div className="absolute inset-x-0 inset-y-0 bg-gray-900 opacity-0 group-hover:opacity-40"></div>

      <div className="absolute inset-x-0 inset-y-0 mx-auto my-auto opacity-0 group-hover:opacity-100 flex flex-col justify-center">
        <div className="flex flex-col">
          <FaPinterest className="text-center mx-auto my-auto text-white text-4xl" />
          <p className="text-center mx-auto my-auto text-white text-2xl">
            Save
          </p>
        </div>
      </div>
    </a>
  );
}

export default function PinCoverSet({ covers, path, description, className }) {
  covers = covers || [];

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  return (
    <div className={className}>
      <h2 className="text-center my-8">Save to Pinterest!</h2>
      <div className="grid grid-cols-3 gap-4">
        {covers.map((cover, index) => (
          <PinCover
            base={data.site.siteMetadata.siteUrl}
            cover={cover}
            path={path}
            description={description}
            key={index + "-" + cover.id}
          ></PinCover>
        ))}
      </div>
    </div>
  );
}
